import { render, staticRenderFns } from "./ProjectBuildings.vue?vue&type=template&id=6d97aace"
import script from "./ProjectBuildings.vue?vue&type=script&lang=ts"
export * from "./ProjectBuildings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports